import { Pipe, PipeTransform } from '@angular/core';
import { TableCollectionAction } from '../models/table-collection-action';
import { TableRowsSelection } from '../models/table-rows-selection';
import { isNil, Nillable } from '@web/utils';

@Pipe({
  name: 'tableCollectionActionDisability',
  standalone: true,
})
export class TableCollectionActionDisabilityPipe<
  Item,
  Filter,
  Action,
> implements PipeTransform {
  public transform(
    selection: Nillable<TableRowsSelection<Item, Filter>>,
    action: Nillable<TableCollectionAction<Item, Filter, Action>>,
  ): Nillable<boolean> {
    if (isNil(action)) {
      return action;
    }

    return action.disability(selection);
  }
}
